<!-- Call Header -->
<app-pathway-call-header
  [isLoading]="false"
  [title]="title()"
  (settingsClicked)="handleSettingsClick()"
  (leaveStepClicked)="handleLeaveStepClick()"
>
</app-pathway-call-header>

<!-- Call Main Content -->
<app-pathway-call-main
  [isLoading]="mainIsLoading()"
  [isPdf]="false"
>
  <app-call-pathway-guide
    [controlService]="controlService()"
    [realtimeService]="realtimeService()"
    [callStore]="callStore()"
    [playerService]="playerService()"
    [deviceSettingsService]="deviceSettingsService()"
    [hideUserVideo]="false"
  />
</app-pathway-call-main>

<!-- Call Footer -->
<app-pathway-call-footer
  *ngIf="!mainIsLoading()"
  [captionText]="captionText()"
  [subtitleKind]="subtitleKind()"
  [subtitleText]="subtitleText()"
  [subtitleFormatting]="subtitleFormatting()"
  [avatarPhotoUrl]="avatarPhotoUrl()"
  [showAvatarPhoto]="showAvatarPhoto()"
  [showSubtitles]="true"
>
  <app-pathway-call-controls
    [isMicOn]="callStore()?.getIsMicOn() ?? false"
    [disableMicButton]="disableMicButton"
    (microphoneClicked)="handleMicrophoneClick()"
    [isVideoOn]="controlService()?.isVideoOn ?? false"
    [isCameraAvailable]="getCameraAvailable()"
    [disableVideoButton]="disableVideoButton"
    [disableConfirmActionButton]="disableConfirmActionButton() || mainIsLoading() || isCheckingReadiness()"
    [suppressConfirmAction]="false"
    confirmActionLabel="learningPathway.NEXT_STEP"
    (videoClicked)="handleVideoClick()"
    (onConfirmActionClicked)="handleConfirmActionClick()"
    [showMicrophoneButton]="true"
    [showCameraButton]="true"
  />
</app-pathway-call-footer>

<!-- Assessment exit modal -->
<app-assessment-exit-modal
  [open]="assessmentExitModalOpen()"
  (resume)="handleAssessmentExitResume()"
  (confirmExit)="handleAssessmentExitConfirm()"
></app-assessment-exit-modal>
